import React from 'react';
import { BiSolidRightArrow } from 'react-icons/bi';

import './BasketTabs.scss';

const INITIAL_INPUTS = 'INITIAL_INPUTS';
const PARAMETERS = 'PARAMETERS';
const ADDITIONAL_PARAMETERS = 'ADDITIONAL_PARAMETERS';

const BasketTabs = ({ selectedTab, onTabChange, shouldBeDisabled }) => (
  <div className="backtest-tabs-button-container">
    <button
      className={`tab-buttons ${
        selectedTab === INITIAL_INPUTS ? 'enabled-tab-button' : 'disabled-tab-button'
      }`}
      onClick={() => onTabChange(INITIAL_INPUTS)}
    >
      1. INITIAL INPUTS
    </button>
    <BiSolidRightArrow size={30} color="#D9D9D9" />
    <button
      className={`tab-buttons ${
        selectedTab === PARAMETERS ? 'enabled-tab-button' : 'disabled-tab-button'
      } ${shouldBeDisabled ? 'tab-buttons-disabled' : ''}`}
      onClick={() => onTabChange(PARAMETERS)}
      disabled={shouldBeDisabled}
    >
      2. PARAMETERS
    </button>
    <BiSolidRightArrow size={30} color="#D9D9D9" />
    <button
      className={`tab-buttons ${
        selectedTab === ADDITIONAL_PARAMETERS ? 'enabled-tab-button' : 'disabled-tab-button'
      } ${shouldBeDisabled ? 'tab-buttons-disabled' : ''}`}
      onClick={() => onTabChange(ADDITIONAL_PARAMETERS)}
      disabled={shouldBeDisabled}
    >
      3. ADDITIONAL PARAMETERS
    </button>
  </div>
);

export default BasketTabs;
